module.exports = __webpack_public_path__ + "static/logo-cffbda0c7bcfe0a681574e6347e4f6b7.png";